module.exports = "pegasus_template/assets/header-6-basic.png";